import { render } from "./XWXLogin.vue?vue&type=template&id=3623d31b&scoped=true"
import script from "./XWXLogin.vue?vue&type=script&lang=js"
export * from "./XWXLogin.vue?vue&type=script&lang=js"

import "./XWXLogin.vue?vue&type=style&index=0&id=3623d31b&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.33_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3623d31b"]])

export default __exports__